import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { message } from "antd";
import Main from "./Component/Main";
import Login from "./Component/common/Login";
import ApplyEcommerceAccount from "./Component/ApplyEcommerceAccount";
import MyAccount from "./Component/MyAccount";
import StoreDetail from "./Component/StoreDetail";
import InComingOrders from "./Component/InComingOrders";
import AddInComingOrder from "./Component/AddInComingOrder";
import UserManagement from "./Component/UserManagement";
import AddEditUser from "./Component/AddEditUser";
import AccountManagement from "./Component/AccountManagement";
import MessageCenter from "./Component/MessageCenter";

// 配置 message 全局位置为垂直中间
message.config({
  top: "50vh",
  duration: 2,
  maxCount: 3,
});

function App() {
  return (
    <Router>
      <Routes>
        {/* 登录页面路由 */}
        <Route path="/" element={<Login />} />

        {/* 管理员控制台 */}
        <Route path="/userAccount" element={<Main />} />

        {/* 用户管理 */}
        <Route path="/user-management" element={<UserManagement />} />
        <Route path="/add-edit-user" element={<AddEditUser />} />

        {/* 账户管理 */}
        <Route path="/account-management" element={<AccountManagement />} />
        <Route
          path="/apply-ecommerce-account"
          element={<ApplyEcommerceAccount />}
        />
        <Route path="/my-account" element={<MyAccount />} />
        <Route path="/store-detail/:id" element={<StoreDetail />} />

        {/* 交易管理 */}
        <Route path="/incoming-orders" element={<InComingOrders />} />
        {/* 新增和编辑订单使用同一个组件 */}
        <Route path="/add-incoming-order" element={<AddInComingOrder />} />

        {/* 消息中心 */}
        <Route path="/message-center" element={<MessageCenter />} />
      </Routes>
    </Router>
  );
}

export default App;
